import React from 'react';
import { styled } from '@mui/system';
import { colors } from '../../../../theme';
import { DividerLine } from '../../../../components/DividerLine';
import { HeaderBar } from '../../../../components/HeaderBar';
import Text from '../../../../components/Text';
import { helpers } from '@simplybenefits/sb-utils';
import i18n from "../../../../localization/i18n";
import tokens from "../../../../localization/tokens";
const Block = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  paddingRight: 10
});
const Row = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  padding: "5px 8px"
});
const HeaderBarNoFill = styled("div")(({
  theme
}) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: 10,
  marginBottom: 10,
  padding: 5,
  borderTop: `1.5px solid ${theme.palette.primary.main}`,
  borderBottom: `1.5px solid ${theme.palette.primary.main}`
}));

/**
 *
 * @param {*} param0
 * @returns
 */
const SpecialityProducts = ({
  specialityProducts,
  isMemberBlock
}) => {
  // if we have no speciality products then don't show the block
  if (!specialityProducts || Object.keys(specialityProducts.products).length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Block, null, !isMemberBlock && /*#__PURE__*/React.createElement(Text, {
    largest: true,
    bold: true,
    customStyle: {
      marginTop: 50
    }
  }, i18n.t(tokens.labels.invoices.specialityProducts)), isMemberBlock ? /*#__PURE__*/React.createElement(HeaderBarNoFill, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      flex: 2,
      textAlign: isMemberBlock ? 'center' : null
    }
  }, "Product"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "Invoicing Type"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "Premium"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "PST/RST"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "GST/HST"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "Total")) : /*#__PURE__*/React.createElement(HeaderBar, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    color: colors.surface,
    customStyle: {
      flex: 2,
      textAlign: isMemberBlock ? 'center' : null
    }
  }, "Product"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    color: colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "Invoicing Type"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    color: colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "Premium"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    color: colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "PST/RST"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    color: colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "GST/HST"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    color: colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "Total")), Object.keys(specialityProducts.products).map(productID => {
    const productCharges = specialityProducts.products[productID];
    return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true,
      customStyle: {
        flex: 2,
        textAlign: isMemberBlock ? 'center' : null
      }
    }, `${productCharges.name} (${productCharges.carrier})`), /*#__PURE__*/React.createElement(Text, {
      small: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, productCharges.invoicingType.charAt(0).toUpperCase() + productCharges.invoicingType.slice(1)), /*#__PURE__*/React.createElement(Text, {
      small: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, helpers.formatNumber(productCharges.premium, 2, true)), /*#__PURE__*/React.createElement(Text, {
      small: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, helpers.formatNumber(productCharges.PST + productCharges.RST, 2, true)), /*#__PURE__*/React.createElement(Text, {
      small: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, helpers.formatNumber(productCharges.GST + productCharges.HST, 2, true)), /*#__PURE__*/React.createElement(Text, {
      small: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, helpers.formatNumber(productCharges.total, 2, true)));
  }), /*#__PURE__*/React.createElement(DividerLine, null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      flex: 2,
      textAlign: isMemberBlock ? 'center' : null
    }
  }, "Total Due"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "-"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, helpers.formatNumber(specialityProducts.premium, 2, true)), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, helpers.formatNumber(specialityProducts.PST + specialityProducts.RST, 2, true)), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, helpers.formatNumber(specialityProducts.GST + specialityProducts.HST, 2, true)), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, helpers.formatNumber(specialityProducts.total || 0, 2, true))));
};
export default SpecialityProducts;